<div class="p-4" style="width: 600px">

    <button tbs-button class="col-12 mb-2" [disabled]="form.invalid" (click)="startProcessing()">
        Start Processing
    </button>
    <form tbs-form tbsLayout="vertical" [formGroup]="form">
        <tbs-form-item>
            <tbs-form-label>S3 Folder URL</tbs-form-label>
            <tbs-form-control [tbsErrorTip]="errorTpl">
                <input tbs-input placeholder="Enter S3 Folder URL" type="text" formControlName="url" />
                <ng-template #errorTpl let-control>
                    @if(control.errors?.['required']) {
                    This field is required.
                    }

                    @if(control.errors?.['invalidS3Uri']) {
                    Must be S3 Uri.
                    }
                </ng-template>
            </tbs-form-control>
        </tbs-form-item>

    </form>
</div>